"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FacebookOutline = {
    name: 'facebook',
    theme: 'outline',
    nameWithTheme: 'facebook-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z'
            },
            children: []
        }
    ]
};
exports.default = FacebookOutline;



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/@ant-design/icons/lib/outline/FacebookOutline.js
// module id = 785
// module chunks = 0